module.exports = __webpack_public_path__ + "static/media/sede.d0ac33db.svg";